module.exports = __webpack_public_path__ + "static/media/sted.53163d8f.png";